import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bscollapse',
	templateUrl:'./BSCollapsePage.html',
	styles: [],
	styleUrls:['./BSCollapsePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSCollapsePage
{
	mdContent_92 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.collapse.BSCollapse;
\`\`\``;
	mdContent_93 = `\`\`\`java
new BSCollapse<>()
\`\`\``;
	mdContent_94 = `\`\`\`java
var toggler = new BSButton<>("Toggle");
var content = new Div<>();
content.setText("Collapsible content here.");
BSCollapse.link(toggler, content, true);
\`\`\``;
}
